export const isAnalyzingCurrentPortfolioRegEx = (portfolioId?: number) =>
  new RegExp(`analysis/results/.+/portfolio/${portfolioId}(/-?\\d*)?$`);
